import { c as _c } from "react/compiler-runtime";
import type { ApiCreateGroupDescription } from "@/generated/models/ApiCreateGroupDescription";
import GroupCreateDirection from "./common/GroupCreateDirection";
import IdentitySearch, { IdentitySearchSize } from "@/components/utils/input/identity/IdentitySearch";
import GroupCreateNumericValue from "./common/GroupCreateNumericValue";
import { ApiGroupFilterDirection } from "@/generated/models/ApiGroupFilterDirection";
export default function GroupCreateCIC(t0) {
  const $ = _c(24);
  const {
    cic,
    setCIC
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [ApiGroupFilterDirection.Received]: "From Identity",
      [ApiGroupFilterDirection.Sent]: "To Identity"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const IDENTITY_LABEL = t1;
  const identityLabel = cic.direction ? IDENTITY_LABEL[cic.direction] : "Identity";
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-mb-4"><p className="tw-mb-0 tw-text-base tw-font-semibold tw-text-iron-50">NIC</p><p className="tw-mb-0 tw-mt-0.5 tw-text-sm tw-text-iron-400">Specify the NIC and optionally set the identity who gave it.</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== cic || $[3] !== setCIC) {
    t3 = cic.user_identity && cic.direction && <div className="tw-mb-4"><GroupCreateDirection direction={cic.direction} label="NIC" setDirection={direction => setCIC({
        ...cic,
        direction
      })} /></div>;
    $[2] = cic;
    $[3] = setCIC;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== cic || $[6] !== setCIC) {
    t4 = identity => setCIC({
      ...cic,
      user_identity: identity
    });
    $[5] = cic;
    $[6] = setCIC;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== cic.user_identity || $[9] !== identityLabel || $[10] !== t4) {
    t5 = <IdentitySearch size={IdentitySearchSize.SM} identity={cic.user_identity} label={identityLabel} setIdentity={t4} />;
    $[8] = cic.user_identity;
    $[9] = identityLabel;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== cic || $[13] !== setCIC) {
    t6 = value => setCIC({
      ...cic,
      min: value
    });
    $[12] = cic;
    $[13] = setCIC;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== cic.min || $[16] !== t6) {
    t7 = <GroupCreateNumericValue value={cic.min} label="NIC at least" labelId="floating_cic" setValue={t6} />;
    $[15] = cic.min;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t7) {
    t8 = <div className="tw-flex tw-flex-col tw-gap-x-3 tw-gap-y-4 lg:tw-gap-y-5">{t5}{t7}</div>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t3 || $[22] !== t8) {
    t9 = <div className="tw-rounded-xl tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-950 tw-p-3 tw-shadow sm:tw-p-5"><div className="tw-flex tw-flex-col">{t2}{t3}{t8}</div></div>;
    $[21] = t3;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}